import Insta from "../../assets/svgs/footer/Insta";
import styles from "./Footer.module.scss";
import LocalizedLink from "../../components/common/localized-link/LocalizedLink";
import { useTranslation } from "react-i18next";
import LinkedIn from "../../assets/svgs/footer/LinkedIn";

const Footer = () => {
  const { t } = useTranslation("translation");

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footer_top}>
          <div className={styles.brand}>
            <h1 className={styles.logo}>LuxMart - {t("online_store")}</h1>
            <div className={styles.hotline}>{t("hotline")}</div>
            <p className={styles.hotline}>{t("address")}</p>
            <a href="tel:+994517003500" className={styles.number}>
              +994517003500
            </a>
            <div className={styles.socials}>
              <a
                href="https://www.linkedin.com/company/alievs-space-mmc/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedIn />
              </a>
              {/* <a href="/#">
                <Facebook />
              </a> */}
              <a
                href="https://www.instagram.com/alievsspace/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Insta />
              </a>
              {/* <a href="/#">
                <Youtube />
              </a> */}
            </div>
          </div>
          <div className={styles.pages}>
            <div className={styles.list}>
              <h4>LuxMart</h4>
              <ul>
                <li>
                  <LocalizedLink to="/">{t("home")}</LocalizedLink>
                </li>
                <li></li>
                <li>
                  <LocalizedLink to="/stores">{t("stores")}</LocalizedLink>
                </li>
                <li>
                  <LocalizedLink to="/contact">{t("contact")}</LocalizedLink>
                </li>
                <li>
                  <LocalizedLink to="/about">{t("about_title")}</LocalizedLink>
                </li>
              </ul>
            </div>
            <div className={styles.list}>
              <h4>{t("help_center")}</h4>
              <ul>
                <li>
                  <LocalizedLink to="/contact">
                    {t("customer_service")}
                  </LocalizedLink>
                </li>
                <li>
                  <LocalizedLink to="/privacy-policy">
                    {t("privacy_policy")}
                  </LocalizedLink>
                </li>
                <li>
                  <LocalizedLink to="/return-delivery">
                    {t("return_delivery")}
                  </LocalizedLink>
                </li>
              </ul>
            </div>
            <div className={styles.list}>
              <h4>{t("partner")}</h4>
              <ul>
                <li>
                  <LocalizedLink to="/becomeseller">
                    {t("become_seller")}
                  </LocalizedLink>
                </li>
                <li>
                  <LocalizedLink to="/partnership">
                    {t("partnership")}
                  </LocalizedLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer_bottom}>
        <div className="container">
          <p>{t("rights")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
